import { PANE_ROW } from "@/components/layout/pane-rows";

/**
 * One button's row in the phone's rail: the height of a link of the folded sidebar
 * (`components/layout/pane-rows.ts`). Every button of the rail is drawn in one (the phone's, the
 * voicemail suggestion's, the day's calls, the missed calls, "Seen before", the form's and the
 * script's), each from its own module, which is why the row is written here once.
 *
 * It has no rule under it. The sidebar has none between two links, and at this pitch a rule under
 * every button was most of what the rail drew.
 */
export const RAIL_CELL = `flex ${PANE_ROW} w-full shrink-0 items-center justify-center`;

/**
 * The room between two of the rail's buttons, set on the column that holds them. More than
 * between two links of the folded sidebar (`PANE_ROW_GAP`): the rail's buttons are round and each
 * can be filled (a call, a pane that is on, a list that is open), and two filled circles 2px
 * apart ran together. So the rail starts level with the sidebar, its phone beside the sidebar's
 * Phone, and its rows then fall a little further apart than the sidebar's.
 */
export const RAIL_GAP = "gap-2";

/**
 * A row of one of the rail's lists ("My calls today", "Missed calls") whose name can be the way to
 * that person's contact (`softphone/contact-link.tsx`). `relative` is what the link is stretched
 * against, so a press anywhere on the row opens the contact, and the row lights while that link is
 * under the pointer or has the keyboard. A row with no link in it never lights: a call with a
 * colleague, or with a number nobody has a contact for, has nowhere to go.
 */
export const RAIL_LIST_ROW =
  "relative has-[a:hover]:bg-surface-hover has-[a:focus-visible]:bg-surface-hover";
